(() => {
    "use strict";

    document.addEventListener("DOMContentLoaded", () => {
        // Header Menu
        setTimeout(() => {
            document.querySelectorAll("#header-main .elementor-nav-menu > .menu-item > .has-submenu").forEach((item) => {
                item.addEventListener("click", (e) => {
                    const link = e.target.closest("a");
                    if (link && link.getAttribute("href") === "#") {
                        e.preventDefault();
                    }
                });
            });
        }, 1000);
    });
})();
